import { BlogMenuItem } from './BlogMenuItem';
import { useMediaMin } from 'hooks/ui/useMediaMin';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import { ListedBlogCategoryType } from 'types/blogCategory';

type ListedBlogCategoryMenuType = ListedBlogCategoryType & {
    onClick?: () => void;
};

export type BlogMenuProps = {
    items?: ListedBlogCategoryMenuType[];
    level?: number;
    activeItemUuid: string;
};

const TEST_IDENTIFIER = 'blocks-blog-menu';

export const BlogMenu: FC<BlogMenuProps> = ({ items: blogCategoryItems, activeItemUuid }) => {
    const isMobileView = !useMediaMin('md');
    const [isMenuCollapsed, setIsMenuCollapsed] = useState(isMobileView);
    const { t } = useTranslation();

    useEffect(() => {
        setIsMenuCollapsed(isMobileView);
    }, [isMobileView]);

    const menuChild: ListedBlogCategoryMenuType = {
        children: [],
        uuid: 'blog-menu',
        name: t('Blog menu'),
        parent: null,
        link: '#',
        onClick: () => setIsMenuCollapsed((prev) => !prev),
    };

    const firstLevel = isMobileView
        ? [menuChild, ...(blogCategoryItems?.[0]?.children || [])]
        : blogCategoryItems?.[0]?.children || [];
    const children = isMenuCollapsed ? (firstLevel.length > 0 ? [firstLevel[0]] : []) : firstLevel;

    if (firstLevel.length <= (isMobileView ? 1 : 0)) {
        return null;
    }

    return (
        <nav className="mb-10 overflow-hidden rounded-md bg-grayLight" data-testid={TEST_IDENTIFIER}>
            <BlogMenuItem
                items={children}
                activeItemUuid={activeItemUuid}
                isMobileView={isMobileView}
                isCollapsed={isMenuCollapsed}
            />
        </nav>
    );
};
